import { render, staticRenderFns } from "./ShiftContacts.vue?vue&type=template&id=29949bb5&lang=pug&"
import script from "./ShiftContacts.vue?vue&type=script&lang=js&"
export * from "./ShiftContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports